export enum FileUploadEventType {
  FILE_TYPE_INVALID = 'FILE_TYPE_INVALID',
  FILE_SIZE_TOO_LARGE = 'FILE_SIZE_TOO_LARGE',
  FILE_DUPLICATED = 'FILE_DUPLICATED',
  FILE_LIMIT_REACHED = 'FILE_LIMIT_REACHED',
  FILE_REMOVED = 'FILE_REMOVED'
}

type FileTypeInvalid = {type: FileUploadEventType.FILE_TYPE_INVALID}
type FileSizeTooLarge = {type: FileUploadEventType.FILE_SIZE_TOO_LARGE}
type FileDuplicated = {type: FileUploadEventType.FILE_DUPLICATED}
type FileLimitReached = {type: FileUploadEventType.FILE_LIMIT_REACHED}
type FileRemoved = {type: FileUploadEventType.FILE_REMOVED; undoRemove: () => void}

export type FileUploadEvent = (
  | FileTypeInvalid
  | FileSizeTooLarge
  | FileDuplicated
  | FileLimitReached
  | FileRemoved
) & {fileName: string}

type DocumentFormat = '.pdf' | '.doc' | '.docx'
type PresentationFormat = '.ppt' | '.pptx'
type ImageFormat = '.png' | '.jpg' | '.jpeg'
type WorksheetFormat = '.xlsx' | '.xls'
type VideoFormat = '.mp4' | '.3gp' | '.mov'

export type AllowedFileFormat =
  | DocumentFormat
  | PresentationFormat
  | ImageFormat
  | WorksheetFormat
  | VideoFormat

export interface AttachementUploadConfig {
  allowedFormats: AllowedFileFormat[]
  maxAttachements: number
  maxFileSizeMB: number
  isAddingEnabled?: boolean
  isDeletingEnabled?: boolean
}
